import cta from '~/components/atoms/a-ctas/a-cta-v2.data'

export default {
  eyebrow: null,
  heading: 'Tribal Worldwide London wins BIMA award for Volkswagen work.',
  image:
    '//a.storyblok.com/f/46530/1500x1000/7fe5d7c38b/kyle-glenn-nxt5htlmlge-unsplash.jpg',
  copy: null,
  cta: [
    {
      ...cta,
      copy: 'Read more',
      href: {
        url: '/our-work',
        cached_url: '/our-work',
      },
      type: 'secondary',
    },
  ],
  component: 'm-card-narrow',
}
